import React, { useEffect, useState } from "react";

function MaintenancePage() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="maintenance-page">
      {/* Animated background gradient that follows cursor */}
      <div
        className="maintenance-bg-glow"
        style={{
          background: `radial-gradient(600px circle at ${mousePos.x}% ${mousePos.y}%, rgba(15, 44, 127, 0.25), transparent 60%)`,
        }}
      />

      {/* Floating particles */}
      <div className="maintenance-particles">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="maintenance-particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${6 + Math.random() * 8}s`,
              width: `${2 + Math.random() * 4}px`,
              height: `${2 + Math.random() * 4}px`,
              opacity: 0.15 + Math.random() * 0.3,
            }}
          />
        ))}
      </div>

      <div className="maintenance-content">
        {/* Animated gear icon */}
        <div className="maintenance-icon-wrapper">
          <div className="maintenance-gear-outer">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="maintenance-gear-svg">
              <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
            </svg>
          </div>
        </div>

        {/* Badge */}
        <div className="maintenance-badge">
          <span className="maintenance-badge-dot" />
          Wartungsmodus aktiv
        </div>

        {/* Main heading */}
        <h1 className="maintenance-title">
          Wir arbeiten an
          <br />
          <span className="maintenance-title-accent">etwas Großem</span>
        </h1>

        {/* Subtext */}
        <p className="maintenance-text">
          Unsere Website wird gerade aktualisiert und optimiert, um Ihnen ein noch
          besseres Erlebnis zu bieten. Wir sind in Kürze zurück.
        </p>

        {/* Divider line */}
        <div className="maintenance-divider" />

        {/* Contact info */}
        <div className="maintenance-contact">
          <p className="maintenance-contact-label">
            Bei dringenden Anfragen erreichen Sie uns unter:
          </p>
          <div className="maintenance-contact-links">
            <a href="mailto:info@pinnarealestate.com" className="maintenance-contact-item">
              <span className="maintenance-contact-icon">✉️</span>
              info@pinnarealestate.com
            </a>
          </div>
        </div>

        {/* Logo */}
        <div className="maintenance-logo">
          PINNA <span>REAL ESTATE</span>
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;
